import * as yup from "yup";

export const addDynamicFields = yup.object({
    display_name: yup.string().required("Label is required"),
    field_type: yup
        .string()
        .oneOf(
            ['text', 'number', 'date', 'boolean', 'select', 'multi_choice', 'checkbox'],
            "Invalid field type"
        )
        .required("Field type is required"),
    settings: yup.array().of(
        yup.object({
            value: yup.string().required("Option value is required"),
        })
    ).when('field_type', {
        is: (val) => ['select', 'multi_choice', 'checkbox'].includes(val),
        then: (schema) => schema.required("Options are required for this field type").min(1, "At least one option is required"),
        otherwise: (schema) => schema.notRequired(),
    }),
    fields: yup.array().of(
        yup.object({
            name: yup.string().required("Field name is required"),
        })
    ),
});
